import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import { connectionString, type LdapDefaults, publicEnvVars } from "./shared";

const DEFAULTS: LdapDefaults = { port: "389", tls: "off" };

export const ldap = defineConnector({
  identifier: "ldap",
  name: "LDAP",
  tagLine: "Bind to an LDAP server",
  logo,
  tags: ["identity", "custom"],
  protocol: "ldap",
  connectionTest: {
    protocol: "ldap",
    connectionString: (config) => connectionString(config, DEFAULTS),
  },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: customAuth("ldap"),
  steps: [
    {
      title: "Enter your LDAP connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "LDAP",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "input",
          label: "Host",
          required: true,
          placeholder: "dc.corp.example.com",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Port",
          required: true,
          defaultValue: "389",
          target: { kind: "configuration", field: "port" },
        },
        {
          kind: "input",
          label: "Bind DN",
          required: true,
          placeholder: "cn=service,ou=users,dc=corp,dc=example,dc=com",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "select",
          label: "TLS",
          required: true,
          defaultValue: "off",
          target: { kind: "configuration", field: "tls" },
          options: [
            { value: "implicit", label: "LDAPS (implicit TLS)" },
            { value: "off", label: "Disabled (plain LDAP)" },
          ],
        },
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Upload a PEM CA certificate for private or self-signed LDAPS servers.",
          target: { kind: "configuration", field: "tlsCaCertificate" },
          visibleWhen: [
            {
              target: { kind: "configuration", field: "tls" },
              notValue: "off",
            },
          ],
        },
      ],
    },
  ],
  publicEnvVars: (config) => publicEnvVars(config, DEFAULTS),
  usageHint: () =>
    "Read LDAP_HOST, LDAP_PORT, LDAP_BIND_DN, and LDAP_PASSWORD from the environment to connect. The bind happens at the proxy, so LDAP_PASSWORD is a placeholder — send it as-is. LDAP_TLS is 'implicit' (LDAPS from the first byte) or 'off' (plain LDAP).",
});
